//cookie code
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
}
function _fnaccept() {
  setCookie("isvisited", "yes", 365);
  $("#shopify-section-cookies-section").fadeOut();
  $("#shopify-section-popup-newsletter").fadeOut();
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1);
    if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
  }
  return "";
}

function getCookie(c_name) {
  return localStorage.getItem(c_name);
}

function setCookie(c_name, value, expiredays) {
  return localStorage.setItem(c_name, value);
}

 window.addEventListener("klaviyoForms", function(e) { 
    if (e.detail.type == 'submit') {
            localStorage.setItem('popupsaved', "yes");   
      console.log(0);
    };
});


    $(window).on('load', function(){  
           
      //alert('1');
      if (localStorage.getItem("popupsaved") === null) {
        //alert('2');
      setTimeout(function(){
        $(".template-index .bth_15_off").trigger('click');
      }, 500);
        }
    });




$(document).ready(function () {
  
  var isvisited = getCookie("isvisited");
  var isvisitedpopup = getCookie("isvisitedpopup");
  if (isvisitedpopup == null || isvisitedpopup == "") {
    $(window).on("load", function () {
      $("#shopify-section-cookies-section").fadeIn();
    //  $("#shopify-section-popup-newsletter").fadeIn();
    });



    
  }

  $(".close_popup, .popup_overlay").click(function () {
    setCookie("isvisitedpopup", "yes", 30);
    $("#shopify-section-popup-newsletter").fadeOut();
  });

  $(".cookie_accept, .reject_btn").click(function () {
    setCookie("isvisitedpopup", "yes", 30);
    $("#shopify-section-cookies-section").fadeOut();
  });

  $(".menu .link_newsletter").click(function (e) {
    e.preventDefault();
    $("#shopify-section-popup-newsletter").fadeIn();
  });
});



$("body").on("mouseover", ".d_header_h3", function (e) {
  $(".dbox-a1").find(".d_level-box").stop().slideUp();
  $(this).closest(".dbox-a1").find(".d_level-box").stop().slideDown();
  $(".d_header_h3").not(this).removeClass("active");
  $(this).addClass("active");
});
$("body").on("mouseover", ".d_tabindex_1", function (e) {
  $('.d_tabcontent_1').addClass("active");
  $('.d_tabcontent_2').removeClass("active");
  $('.d_tabcontent_3').removeClass("active");
  $('#one_video video').get(0).pause();
  $('#one_video video').attr('loop', 'true');
});
$("body").on("mouseover", ".d_tabindex_2", function (e) {
  $('.d_tabcontent_2').addClass("active");
  $('.d_tabcontent_1').removeClass("active");
  $('.d_tabcontent_3').removeClass("active");
    $('#one_video video').get(0).pause();
   $('#one_video video').attr('loop', 'true');
});
$("body").on("mouseover", ".d_tabindex_3", function (e) {
  $('.d_tabcontent_3').addClass("active");
  $('.d_tabcontent_1').removeClass("active");
  $('.d_tabcontent_2').removeClass("active");
  $('#one_video button').trigger("click");
  $('#one_video video').get(0).play();
  $('#one_video video').attr('loop', 'true');
});


$("body").on("click", ".m_header_h3", function (e) {
  $(".mbox-a1").find(".m_level-box").stop().slideUp();
  $(this).closest(".mbox-a1").find(".m_level-box").stop().slideDown();
  $(".m_header_h3").not(this).removeClass("active");
  $(this).addClass("active");
});
$("body").on("click", ".m_tabindex_1", function (e) {
  $('.d_tabcontent_1').addClass("active");
  $('.d_tabcontent_2').removeClass("active");
  $('.d_tabcontent_3').removeClass("active");
  $('#one_video video').get(0).pause();
  $('#one_video video').attr('loop', 'true');
});
$("body").on("click", ".m_tabindex_2", function (e) {
  $('.d_tabcontent_2').addClass("active");
  $('.d_tabcontent_1').removeClass("active");
  $('.d_tabcontent_3').removeClass("active");
    $('#one_video video').get(0).pause();
   $('#one_video video').attr('loop', 'true');
});
$("body").on("click", ".m_tabindex_3", function (e) {
  $('.d_tabcontent_3').addClass("active");
  $('.d_tabcontent_1').removeClass("active");
  $('.d_tabcontent_2').removeClass("active");
  $('#one_video button').trigger("click");
  $('#one_video video').get(0).play();
  $('#one_video video').attr('loop', 'true');
});


/*
$("body").on("mouseover", ".header_h3", function (e) {
  $(".box-a1").find(".level-box").stop().slideUp();
  $(this).closest(".box-a1").find(".level-box").stop().slideDown();
  $(".header_h3").not(this).removeClass("active");
  $(this).addClass("active");
});

$("body").on("mouseover", ".tabindex_1", function (e) {
  $('.tabcontent_1').addClass("active");
  $('.tabcontent_2').removeClass("active");
  $('.tabcontent_3').removeClass("active");
  $('#one_video video').get(0).pause();
   $('#one_video video').attr('loop', 'true');
});
$("body").on("mouseover", ".tabindex_2", function (e) {
  $('.tabcontent_2').addClass("active");
  $('.tabcontent_1').removeClass("active");
  $('.tabcontent_3').removeClass("active");
    $('#one_video video').get(0).pause();
   $('#one_video video').attr('loop', 'true');
});
$("body").on("mouseover", ".tabindex_3", function (e) {
  $('.tabcontent_3').addClass("active");
  $('.tabcontent_1').removeClass("active");
  $('.tabcontent_2').removeClass("active");
  $('#one_video button').trigger("click");
  $('#one_video video').get(0).play();
   $('#one_video video').attr('loop', 'true');

});
*/


$("body").on("click", ".mo_menu", function () {
  $(this).toggleClass("active");
  $(".mo_menu-row").toggleClass("active");
   $("#MainContent").toggleClass("blur_active");
});


$("body").on("click", ".bth_15_off", function () {
   $("#shopify-section-popup-newsletter").slideToggle();
});

$('a.link_accessibility').attr('href', 'javascript:void(0)');
$(document).on("click", ".link_accessibility", function () {
   $("#accessiblyAppDialogButton").trigger('click');
});




$(document).ready(function () {
setTimeout(function(){

$("#input_checkbox").change(function() {
    $("form.klaviyo-form").submit(function(event) {
      if (!$("#input_checkbox").is(":checked")) {
        event.preventDefault();
        alert("Please agree to the terms and conditions before submitting the form.");
      }
    });

    $("form.klaviyo-form button").prop("disabled", !$("#input_checkbox").is(":checked"));
  });
}, 2000);


 // unseen page file upload

$('#ContactForm-upload').on('click', function() {
    $(".file_names").html("");
  })
if ($('#ContactForm-upload')[0]) {
	var fileInput = document.querySelector('label[for="ContactForm-upload"]');
	fileInput.ondragover = function() {
		this.className = "et_pb_contact_form_label changed";
		return false;
	}
	fileInput.ondragleave = function() {
		this.className = "et_pb_contact_form_label";
		return false;
	}
	fileInput.ondrop = function(e) {
		e.preventDefault();
		var fileNames = e.dataTransfer.files;
		for (var x = 0; x < fileNames.length; x++) {
			$=jQuery.noConflict();
			$('label[for="ContactForm-upload"]').append("<div class='file_names'>"+ fileNames[x].name +"</div>");
		}
	}
	$('#ContactForm-upload').change(function() {
		var fileNames = $('#ContactForm-upload')[0].files[0].name;
		$('label[for="ContactForm-upload"]').append("<div class='file_names'>"+ fileNames +"</div>");
		$('label[for="ContactForm-upload"]').css('background-color', '##eee9ff');
	});
	}



});

$(window).scroll(function(){
    if ($(this).scrollTop() > 50) {
       $('.shopify-section-group-header-group').addClass('mo_active');
    } else {
      $('.shopify-section-group-header-group').removeClass('mo_active');
    }
});

 (function() { 
     var REDIRECT_PATH = '/account'; 
   
     var selector = '#create_customer, form[action$="/account"][method="post"]', 
         $form = document.querySelectorAll(selector)[0]; 
   
     if ($form) { 
       $redirect = document.createElement('input'); 
       $redirect.setAttribute('name', 'return_to'); 
       $redirect.setAttribute('type', 'hidden'); 
       $redirect.value = REDIRECT_PATH; 
       $form.appendChild($redirect);  
     } 
   })();